// src/components/HeroSection.js (CÓDIGO FINAL CORREGIDO DE JS)
import React, { useState, useEffect } from 'react';
import './HeroSection.css'; 

// 🛑 IMPORTAR LAS IMÁGENES DE FONDO 
import imagen1 from '../assets/images/imagen1.png';
import imagen2 from '../assets/images/imagen2.png';
import imagen3 from '../assets/images/imagen3.png';

const heroImages = [imagen1, imagen2, imagen3];
const cycleDuration = 5000; 

const HeroSection = () => { 
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentImageIndex(prevIndex => 
                (prevIndex + 1) % heroImages.length
            );
        }, cycleDuration);
        return () => clearInterval(timer);
    }, []); 

    const dynamicBackgroundStyle = {
        // 🛑 CAMBIO CLAVE: ELIMINAMOS EL DEGRADADO OSCURO (rgba(0,0,0,0.6)...)
        backgroundImage: `url(${heroImages[currentImageIndex]})`,
    };

    return (
        <section 
            id="inicio" 
            className="hero-container"
            style={dynamicBackgroundStyle} 
        >
            <div className="hero-content">
                <h1>Asesoría Legal, Económica y Patrimonial de Confianza en Venezuela.</h1>
                <p>Más de 30 años de experiencia al servicio de su empresa y patrimonio. Conectamos contigo sin importar tu ubicación.</p>
            </div>
        </section>
    );
};

export default HeroSection;